import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { AppConfig } from '../../core/configuration/app.config';
import { AppA3DocConnection } from '../../core/models/appA3DocConnection.model';
import { AppA3DocConnectionService } from '../../core/services/appA3DocConnection.service';
import { AppA3DocService } from '../../core/services/appA3Doc.service';

@Component({
  selector: 'app-a3DocCloud-settings',
  templateUrl: './a3DocCloud-settings.component.html',
  styleUrls: ['./a3DocCloud-settings.component.scss'],
  providers: [AppA3DocConnectionService, AppA3DocService]
})
export class A3DocCloudSettingsComponent implements OnInit {

  model: AppA3DocConnection;
  typePassword = 'password';
  typeApiKey = 'password';
  buttonText: string = "Comprobar conexión";
  buttonIcon: string | null = null;

  constructor(private _a3DocConnectionService: AppA3DocConnectionService,
    protected appA3DocService: AppA3DocService,
    protected _messageDialog: MessageDialog,
    protected _http: HttpClient) { }

  ngOnInit() {
    this._a3DocConnectionService.getModel().subscribe(
      res => {
        this.model = res ? res : new AppA3DocConnection(); // Si no hay respuesta, asignar un modelo vacío
      },
      err => {
        this._messageDialog.ShowAlert("No se han podido obtener los datos de conexión", "Error");
        this.model = new AppA3DocConnection(); // En caso de error, inicializar el modelo
      });
  }

  trimModel() {
    this.model.tenant = this.model.tenant ? this.model.tenant.trim() : '';
    this.model.user = this.model.user ? this.model.user.trim() : '';
    this.model.password = this.model.password ? this.model.password.trim() : '';
    this.model.apiKey = this.model.apiKey ? this.model.apiKey.trim() : '';
  }

  save() {
    this.trimModel();

    if (this.model.a3docConnection1) {
      this._a3DocConnectionService.updateModel(this.model.a3docConnection1, this.model).subscribe(res => {
        this._messageDialog.ShowMessage("Actualización realizada con éxito", "Guardado");
      },
        err => this._messageDialog.ShowException(err));
    } else {
      this._a3DocConnectionService.createModel(this.model).subscribe(res => {
        this._messageDialog.ShowMessage("Creación realizada con éxito", "Atención");
      },
        err => this._messageDialog.ShowException(err));
    }
  }

  testConnection() {
    this.buttonText = "Comprobando...";
    this.buttonIcon = null;
    this.trimModel();

    this.appA3DocService.getToken({
      tenant: this.model.tenant,
      password: this.model.password,
      user: this.model.user,
      apiKey: this.model.apiKey,
      isTest: true
    }).subscribe({
      next: (response) => {
        this.appA3DocService.getLivesHrCategoriesIds().then((ids) => {

          if (!ids || ids.length === 0) {
            this._messageDialog.ShowAlert("La categoría 'LivesHR' no ha sido encontrada. Es necesario crearla para continuar.", "Error");
            this.updateButtonTextWithTimeout("Conexión exitosa", "check");
          } else {
            this.appA3DocService.setCustomLivesHrCategories({ containerIds: ids }).then(
              (result) => {
                this.updateButtonTextWithTimeout("Conexión exitosa", "check");
              }).catch((error) => {
                console.error('Error al guardar las categorías:', error);
                this.updateButtonTextWithTimeout("Conexión fallida", "times");
              });

            this.updateButtonTextWithTimeout("Conexión exitosa", "check");
          }
        }).catch((error) => {
          console.error('Error al obtener las categorías:', error);
          this.updateButtonTextWithTimeout("Conexión fallida", "times");
        });
      },
      error: (error) => {
        console.error("Error en la conexión:", error);
        this.updateButtonTextWithTimeout("Conexión fallida", "times");
      }
    });

  }

  updateButtonTextWithTimeout(newText: string, newIcon: string) {
    this.buttonText = newText;
    this.buttonIcon = newIcon;

    // Restablece el botón después de 5 segundos
    setTimeout(() => {
      this.buttonText = "Comprobar conexión";
      this.buttonIcon = null;
    }, 5000);
  }



  toggleTypeApiKey() {
    this.typeApiKey = this.typeApiKey === 'password' && 'text';
  }

  toggleTypePassword() {
    this.typePassword = this.typePassword === 'password' && 'text';
  }

}
